import { get } from "../../../utils/objectHelpers";

<if(get(input, "name", null) === 'AUTHORIZED_SELLER')>
    <ebay-program-badge-authenticity-guaranteed />
</if>
